define('widget/favorite-modal', ['jquery', 'common/util', 'log'], ($, util, log) => {
    /* istanbul ignore next */
    const init = () => {
        const twocodeObj = util.twocodeMap.favorite_common;
        // 替换二维码图片并发送微信二维码曝光埋点
        $('#js-collection-modal').find('.wx-service').attr('src', twocodeObj.imgSrc);
        log.push(['_trackEvent', twocodeObj.logName, 'show']);

        $('#js-collection-mask').show();
        $('#js-collection-modal').show();
        $('#js-collection-modal .close-btn').one('click', () => {
            $('#js-collection-mask').hide();
            $('#js-collection-modal').hide();
        });
    };
    return { init };
});
